import React from 'react';

import { ThemeContext } from '.';
import type { ThemeContextValues } from '.';

const useTheme = () => React.useContext<ThemeContextValues>(ThemeContext);

export default useTheme;
